<template>
    <div class="card" @click="showCard">

        <div class="logo">
          <img :src="club.shield" />
        </div>
        <div class="content">
            <div class="legend">{{$t('club')}}</div>
            <div class="title">{{club.name}}</div>
            <div v-if="role" class="role" :class="'r' + role.id">{{role.name}}</div>
        </div>
    </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  components: { },
  props: { club: Object, role: Object, is_rel: Boolean, id_rel: String },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
	  	showCard(){

          this.$card.club( this.club, this.is_rel, this.id_rel );
      }
  },
  created() {
  	var self = this;
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .card {
    padding: 6px;
    border-radius: 3px;
    margin-bottom: 15px;
    overflow: hidden;
    background: url('/img/right-arrow.svg') no-repeat right 10px center #fff;
    background-size: 20px;
    cursor: pointer;
    
    
    .legend {
      font-size: 14px;
      font-weight: lighter;
      text-transform: uppercase;
      color: #acacac;
    }
    .logo {
      height: 90px;
      width: 90px;
      vertical-align: middle;
      float: left;
      padding: 10px;
    }
    .content {
      width: calc( 100% - 90px );
      float: left;
      padding-top: 10px;
    }
    
    .title {
      line-height: 45px;
      margin: 0 auto;
      font-size: 16px !important;
      margin-bottom: 5px;


    }

    .role {
        text-align: left;
        font-size: 14px;


        & .value {
            font-size: 14px;
            text-transform: uppercase;
        }
    }
  }
</style>